/** Canonical AdaptiveRT module id (stored in new calculation records). */
export const ADAPTIVE_RT_MODULE_ID = 'adaptive_rt';

const ADAPTIVE_RT_MODULES = new Set([ADAPTIVE_RT_MODULE_ID]);

export function isAdaptiveRtModule(mode) {
  return ADAPTIVE_RT_MODULES.has(mode);
}

/** @param {string|undefined|null} mode */
export function normalizeModuleId(mode) {
  return mode;
}
